export const extraerNumeros = (texto) => {
  return texto?.replace(/\D/g, "");
};
